// rum.config.ts
import type { RumInitConfiguration } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react/cjs/domain/reactPlugin";

import { scrubRumEvent } from "./rum-privacy";

const rumConfig: RumInitConfiguration = {
  applicationId: process.env.DD_RUM_APPLICATION_ID || "",
  clientToken: process.env.DD_RUM_CLIENT_TOKEN || "",
  site: process.env.DD_SITE || "us3.datadoghq.com",
  env: process.env.APP_ENV,
  version: process.env.GIT_RELEASE_TAG,
  startSessionReplayRecordingManually: true,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  trackAnonymousUser: false,
  defaultPrivacyLevel: "mask",
  enablePrivacyForActionName: true,
  beforeSend: (event, context) => scrubRumEvent(event, context),
  plugins: [reactPlugin({ router: true })],
  allowedTracingUrls: [
    {
      match: /^https:\/\/pawnsguat\.moneymaxservices\.com(?:\/|$)/,
      propagatorTypes: ["datadog", "tracecontext"],
    },
    {
      match: /^https:\/\/pawnsg\.moneymaxservices\.com(?:\/|$)/,
      propagatorTypes: ["datadog", "tracecontext"],
    },
    {
      match: /^https:\/\/pawnmyuat\.moneymaxservices\.com(?:\/|$)/,
      propagatorTypes: ["datadog", "tracecontext"],
    },
    {
      match: /^https:\/\/mis\.pawnmyuat\.moneymaxservices\.com(?:\/|$)/,
      propagatorTypes: ["datadog", "tracecontext"],
    },
    {
      match: /^https:\/\/pawnmy\.moneymaxservices\.com(?:\/|$)/,
      propagatorTypes: ["datadog", "tracecontext"],
    },
  ],
};

export function getRumConfig(): RumInitConfiguration {
  return { ...rumConfig, service: "frontend_moneymax_customer" };
}

export function isRumEnabled(): boolean {
  return (
    Boolean(process.env.DD_RUM_APPLICATION_ID?.trim()) &&
    Boolean(process.env.DD_RUM_CLIENT_TOKEN?.trim())
  );
}
